export default "__VITE_ASSET__d7472253__"